/* eslint-disable */
import React, { Component } from 'react'
import { getDateWithTimezone } from '../../utils/timeHelpers'
import PropTypes from 'prop-types'
import Text from 'cms/CmsText'

class ThemeCountDown extends Component {
  constructor(props) {
    super(props)
    const {
      endTime,
    } = props
    this.state = { timeRemaining : endTime - this.getNowTime() }
    this.tick()
  }

  componentWillReceiveProps(nextProps){
    const {
      endTime: nextEndTime
    } = nextProps
    const {
      endTime: prevEndTime
    } = this.props
    if(nextEndTime !== prevEndTime){
      clearInterval(this.countdownTimeout)
      this.initialTimeRemaining(nextEndTime)
    }
  }

  componentWillUpdate(nextProps, nextState){
    const {
      timeRemaining: nextTimeRemaining
    } = nextState
    const {
      timeRemaining: prevTimeRemaining
    } = this.state

    if(nextTimeRemaining < 0 && prevTimeRemaining > 0){
      clearInterval(this.countdownTimeout);
    }
  }

  componentWillUnmount(){
    clearInterval(this.countdownTimeout);
  }

  initialTimeRemaining = (endTime) => {
    this.setState({ timeRemaining : endTime - this.getNowTime() })
    this.tick()
  }

  tick = () => {
    this.countdownTimeout = setInterval(() => {
      this.setState({ timeRemaining: this.state.timeRemaining - 1000})
    }, 1000)
  }

  getNowTime = () => getDateWithTimezone().getTime()

  getFormattedTime = (milliseconds) => {
    const totalSeconds = Math.round(milliseconds / 1000)

    let seconds = parseInt(totalSeconds % 60, 10)
    let minutes = parseInt(totalSeconds / 60, 10) % 60
    let hours = parseInt(totalSeconds / (60 * 60), 10) % 24
    let days = parseInt(totalSeconds / (24 * 60 * 60), 10)

    seconds = seconds < 10 ? `0${seconds}` : seconds
    minutes = minutes < 10 ? `0${minutes}` : minutes
    hours = hours < 10 ? `0${hours}` : hours
    days = days < 10 ? `0${days}` : days

    return `${days} : ${hours} : ${minutes} : ${seconds}`
  }

  render() {
    const {
      timeRemaining,
    } = this.state
    const {
      style,
      settings,
      timeoutMessage
    } = this.props
    return (
      timeRemaining > 0 ?
        (<Text as="p" style={style} {...settings}>{this.getFormattedTime(timeRemaining)}</Text>)
      :
        (<Text as="p" style={style} {...settings}>{timeoutMessage}</Text>)
    )
  }
}

ThemeCountDown.propTypes = {
  endTime: PropTypes.number.isRequired,
  timeoutMessage: PropTypes.string.isRequired,
}
ThemeCountDown.defaultProps = {
}

export default ThemeCountDown



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/countDown/ThemeCountDown.js